import React from 'react';
import { useTranslation } from 'react-i18next';
import { BlueprintViewMode } from '../../../store/blueprints/blueprintsTypes';
import BzmIcon from '../../../components/icons/BzmIcon';

interface Props {
  viewMode: BlueprintViewMode;
  onViewModeChange: (mode: BlueprintViewMode) => void;
  onCreate: () => void;
  canCreate: boolean;
}

const BlueprintsToolbar = (props: Props) => {
  const { t } = useTranslation('blueprints');
  return (
    <div className="d-flex align-items-center" style={{ gap: 12 }}>
      <div className="btn-group btn-group-sm" role="group">
        <button
          type="button"
          data-test="bp-view-grid"
          title={t('view.grid')}
          aria-label={t('view.grid')}
          className={`btn d-flex align-items-center ${
            props.viewMode === 'GRID' ? 'btn-primary' : 'btn-outline-secondary'
          }`}
          onClick={() => props.onViewModeChange('GRID')}
        >
          <BzmIcon variant="icon-bzm-chart-2x2-grid" size={16} className="mr-1" />
          {t('view.grid')}
        </button>
        <button
          type="button"
          data-test="bp-view-list"
          title={t('view.list')}
          aria-label={t('view.list')}
          className={`btn d-flex align-items-center ${
            props.viewMode === 'LIST' ? 'btn-primary' : 'btn-outline-secondary'
          }`}
          onClick={() => props.onViewModeChange('LIST')}
        >
          <BzmIcon variant="icon-bzm-list" size={16} className="mr-1" />
          {t('view.list')}
        </button>
      </div>
      {props.canCreate && (
        <button type="button" data-test="bp-new" className="btn btn-primary" onClick={props.onCreate}>
          {t('new')}
        </button>
      )}
    </div>
  );
};

export default BlueprintsToolbar;
